import Api from '@/api';
import { Http } from '../../../utilities/util';

const loadCustomer = (context, customerId) => new Promise((resolve, reject) => {
  Api.personService.getCustomer(customerId)
    .then(response => {
      context.commit('setError', null);
      context.commit('setCustomer', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setCustomer', {});
      const httpError = Http.createError(
        error,
        'customer.actions.loadCustomer',
        { customerId },
      );
      Http.setGlobalError(context, httpError);
      reject();
    });
});

const saveCustomer = (context, customerData) => new Promise((resolve, reject) => {
  const payload = {
    ...customerData,
    address1: customerData.primaryAddress.address1,
    address2: customerData.primaryAddress.address2,
    city: customerData.primaryAddress.city,
    postalCode: customerData.primaryAddress.postalCode,
    state: customerData.primaryAddress.state,
  };

  Api.personService.postCustomer(payload.legacyId, payload)
    .then(response => {
      context.commit('setCustomer', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setError', error.data);
      reject();
    });
});

const savePassword = (context, customerData) => new Promise((resolve, reject) => {
  context.commit('setPasswordLoading', true);
  context.commit('setPasswordError', null);

  Api.personService.postPassword(customerData.personId, customerData.password)
    .then(() => {
      context.commit('setPasswordLoading', false);
      resolve();
    })
    .catch(error => {
      context.commit('setPasswordError', error);
      context.commit('setPasswordLoading', false);
      reject();
    });
});

export default {
  loadCustomer,
  saveCustomer,
  savePassword,
};
